module.exports = __webpack_public_path__ + "img/20210712_093043.61de5c75.jpg";